import logger from "@utils/logger";

declare global {
  interface Window {
    /* eslint-disable @typescript-eslint/naming-convention */
    VITE_REACT_APP_BACKEND_BASE_URL?: string;
    VITE_REACT_APP_ADMIN_BASE_URL?: string;
    VITE_REACT_APP_FRONTEND_BASE_URL?: string;
    VITE_REACT_APP_ENVIRONMENT?: string;
    VITE_REACT_APP_COOKIE_BANNER_ACTIVE?: boolean;
    VITE_REACT_APP_INFOS_ACTIVE?: boolean;
    COMPT_EXPERT_URL?: string;
    /* eslint-enable @typescript-eslint/naming-convention */
  }
}

interface ConfigInterface {
  backendBaseUrl: string;
  adminBaseUrl: string;
  frontendBaseUrl: string;
  environment: string;
  cookieBannerActive: boolean;
  appInfosActive: boolean;
  comptExpertUrl: string;
}

const configuration: ConfigInterface = {
  backendBaseUrl:
    import.meta.env.VITE_REACT_APP_BACKEND_BASE_URL ||
    window.VITE_REACT_APP_BACKEND_BASE_URL ||
    "",
  adminBaseUrl:
    import.meta.env.VITE_REACT_APP_ADMIN_BASE_URL ||
    window.VITE_REACT_APP_ADMIN_BASE_URL ||
    "MISSING_REACT_APP_ADMIN_BASE_URL",
  frontendBaseUrl:
    import.meta.env.VITE_REACT_APP_FRONTEND_BASE_URL ||
    window.VITE_REACT_APP_FRONTEND_BASE_URL ||
    "MISSING_REACT_APP_FRONTEND_BASE_URL",
  environment:
    import.meta.env.VITE_REACT_APP_ENVIRONMENT ||
    window.VITE_REACT_APP_ENVIRONMENT ||
    "MISSING_REACT_APP_ENVIRONMENT",
  cookieBannerActive:
    import.meta.env.VITE_REACT_APP_COOKIE_BANNER_ACTIVE === "true" ||
    window.VITE_REACT_APP_COOKIE_BANNER_ACTIVE ||
    false,
  appInfosActive:
    import.meta.env.VITE_REACT_APP_INFOS_ACTIVE === "true" ||
    window.VITE_REACT_APP_INFOS_ACTIVE ||
    false,
  comptExpertUrl:
    import.meta.env.COMPT_EXPERT_URL ||
    window.COMPT_EXPERT_URL ||
    "COMPT_EXPERT_URL",
};

logger.info(JSON.stringify(configuration));

export default configuration;
